export const SEQUENCE_LIST_REQUEST = "SEQUENCE_LIST_REQUEST"
export const SEQUENCE_LIST_SUCCESS = "SEQUENCE_LIST_SUCCESS"
export const SEQUENCE_LIST_FAIL = "SEQUENCE_LIST_FAIL"